<template>
  <div id="main-content" style="background: #ffffff;">
    <div style="padding: 10px 20px;font-size: 16px;user-select: none;">
      <div class="norm-panel">
        <div class="norm-panel-label">数据维度：</div>
        <div style="flex: 1">
          <div class="norm-panel-item"
               :class="addInfo[dimensionItem.type].includes(dimensionItem.code)?'active':''"
               @click="choiceNorm(dimensionItem)"
               :key="dimensionItem.code"
               v-for="dimensionItem in dimensionList">
            {{dimensionItem.name}}
          </div>
        </div>
      </div>
      <div class="norm-panel" >
        <div class="norm-panel-label">筛选条件：</div>
        <div style="flex: 1">
          <div class="norm-panel-item"
               :class="addInfo[conditionItem.type].includes(conditionItem.code)?'active':''"
               @click="choiceNorm(conditionItem)"
               :key="conditionItem.code"
               v-for="conditionItem in conditionList">
            {{conditionItem.name}}
          </div>
        </div>
      </div>
      <div class="norm-panel" >
        <div class="norm-panel-label">数据指标：</div>
        <div style="flex: 1;background: #EEEEEE;padding: 0 15px;border-radius: 5px;margin: 5px 10px;">
          <div class="norm-panel"
               v-for="(dataItemList,dataItemIndex) in dataList">
            <div class="norm-panel-label text-no">{{$store.state.report.dataCategory[dataItemIndex]}}</div>
            <div style="flex: 1;margin-left: 20px;" >
              <div class="norm-panel-item"
                   :class="addInfo[dataItem.type].includes(dataItem.code)?'active':''"
                   @click="choiceNorm(dataItem)"
                   v-for="dataItem in dataItemList">
                {{dataItem.name}}
              </div>
            </div>
          </div>
          <div class="norm-panel">
            <div class="norm-panel-label text-no">组合指标</div>
            <div style="flex: 1px;margin-left: 20px;" >
              <div class="norm-panel-item"
                   :class="addInfo[composeItem.type].includes(composeItem.code)?'active':''"
                   @click="choiceNorm(composeItem)"
                   v-for="composeItem in composeList">{{composeItem.name}}({{composeItem.rule}})</div>
              <div class="norm-panel-item" style="color: #1890ff" @click="addCompose"><a-icon type="plus-circle"/></div>
              <a-modal
                title="新增组合指标"
                :visible="composeVisible"
                @ok="doAddCompose()"
                @cancel="()=>{composeVisible=false}">
                <a-form-model :rules="composeRules"
                              :model="composeInfo" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
                  <a-form-model-item label="指标名称" prop="name">
                    <a-input v-model="composeInfo.name" />
                  </a-form-model-item>
                  <a-form-model-item label="指标描述" prop="desc">
                    <a-input v-model="composeInfo.desc" />
                  </a-form-model-item>
                  <a-form-model-item label="指标规则" prop="rule">
                    <a-input v-model="composeInfo.rule" />
                  </a-form-model-item>
                </a-form-model>
                <div style="flex: 1;background: #EEEEEE;padding: 0 15px;border-radius: 5px;margin: 0 10px;">
                  <div class="norm-panel"
                       v-for="(dataItemList,dataItemIndex) in dataList">
                    <div class="norm-panel-label text-no">{{$store.state.report.dataCategory[dataItemIndex]}}</div>
                    <div style="flex: 1" >
                      <div class="norm-panel-item"
                           :class="composeChoice.includes(dataItem.code)?'active':''"
                           @click="choiceComposeNorm(dataItem)"
                           v-for="dataItem in dataItemList">
                        {{dataItem.name}}
                      </div>
                    </div>
                  </div>
                </div>
              </a-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center">
      <a-button type="primary" @click="addReport()">创建图表</a-button>
      <a-modal
        title="创建看板"
        :visible="reportVisible"
        @ok="doAddReport()"
        @cancel="()=>{reportVisible=false}"
      >
        <a-form-model :rules="addRules"
                      :model="addInfo" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
          <a-form-model-item label="看板名称" prop="name">
            <a-input v-model="addInfo.name" />
          </a-form-model-item>
          <a-form-model-item label="看板描述" prop="desc">
            <a-input v-model="addInfo.desc"/>
          </a-form-model-item>
          <a-form-model-item label="所有者">
            {{$store.getters.getUserInfo['name']}}
          </a-form-model-item>
          <a-form-model-item label="看板类型" prop="type">
            <a-radio-group v-model="addInfo.type">
              <a-radio :value="typeIndex"
                       :key="typeIndex"
                       v-for="(typeItem,typeIndex) in $store.state.report.panelType">
                {{typeItem}}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
    <div style="display: flex;align-items: flex-end;justify-content: space-between;padding:20px 20px 10px 20px;">
      <div style="flex: 1;">
        <a-range-picker style="width: 200px;margin: 5px;" v-if="addInfo.condition.includes('date')" valueFormat="YYYY-MM-DD" disabled />
        <a-select style="width: 200px;margin: 5px;" :placeholder="codeNameMap.condition[filterItem]"
                  v-if="filterItem!=='date'"
                  :key="filterItem"
                  v-for="filterItem in addInfo.condition" disabled></a-select>
      </div>
      <div style="display: flex;align-items: flex-start;justify-content: flex-end;font-size: 16px;min-width: 200px;">
        <div style="margin-right: 10px;cursor: pointer"><a-icon type="table" /></div>
        <div style="margin-right: 10px;cursor: pointer"><a-icon type="bar-chart" /></div>
        <div style="margin-right: 10px;cursor: pointer"><a-icon type="line-chart" /></div>
        <div style="margin-right: 10px;cursor: pointer"><a-icon type="pie-chart" /></div>
        <div style="cursor: pointer"><a-icon type="download" />下载数据</div>
      </div>
    </div>
    <div style="padding: 10px 20px 20px 20px;flex: 1;">
      <a-table :columns="getTableField" :data-source="[]" bordered :pagination="false">
        <template slot="name" slot-scope="text">
          <a>{{ text }}</a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import {AddNorm, AddPanel, GetNormList} from "../../api/v1/analysis";

export default {
  name: "Add",
  data(){
    return {
      typeList:{
        'public':'公开',
        'private':'私有',
        'protected':'保护',
      },

      reportVisible:false,
      addRules:{
        name: [
          { required: true, message: '看板名称必须', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '看板类型必须', trigger: 'blur' },
        ],
      },
      addInfo:{
        name:'',
        desc:'',
        type:'private',
        dimension:[],
        condition:[],
        data:[],
      },

      composeVisible:false,
      composeRules:{},
      composeInfo:{
        rule:'',
        type:'data',
        category:'compose',
      },
      composeChoice:[],

      dimensionList:[],
      conditionList:[],
      dataList:{},
      composeList:[],
      codeNameMap:{
        dimension:{},
        condition:{},
        data:{},
      }
    }
  },
  computed:{
    getTableField(){
      let _field = []
      this.addInfo.dimension.forEach(item => {
        _field.push({
          title:this.codeNameMap.dimension[item],
          dataIndex:item
        })
      })
      this.addInfo.data.forEach(item => {
        _field.push({
          title:this.codeNameMap.data[item],
          dataIndex:item
        })
      })
      return _field
    }
  },
  mounted() {
    this.initNorm()
  },
  methods:{
    choiceNorm(normItem){
      let _norm_index = this.addInfo[normItem.type].indexOf(normItem.code)
      if (_norm_index===-1){
        this.codeNameMap[normItem.type][normItem.code] = normItem.name
        this.addInfo[normItem.type].push(normItem.code)
      }else{
        delete this.codeNameMap[normItem.type][normItem.code]
        this.addInfo[normItem.type].splice(_norm_index,1)
      }
    },
    choiceComposeNorm(normItem){
      let _norm_index = this.composeChoice.indexOf(normItem.code)
      if (_norm_index===-1){
        this.composeInfo.rule += '['+normItem.name+']'
        this.composeChoice.push(normItem.code)
      }else{
        this.composeInfo.rule = this.composeInfo.rule.replace(normItem.name,'')
        this.composeInfo.rule = this.composeInfo.rule.replace('[]','')
        this.composeChoice.splice(_norm_index,1)
      }
    },
    initNorm(){
      GetNormList({}).then(resp => {
        if (resp.code===200){
          this.dimensionList = []
          this.conditionList = []
          this.composeList = []
          this.dataList = {}
          resp.data.forEach(item => {
            switch (item.type){
              case 'dimension':
                this.dimensionList.push(item)
                break
              case 'condition':
                this.conditionList.push(item)
                break
              case 'data':
                if (item.category==='compose'){
                  this.composeList.push(item)
                }else{
                  if (!this.dataList[item.category]){
                    this.dataList[item.category] = []
                  }
                  this.dataList[item.category].push(item)
                }
                break
            }
          })
        }
      })
    },
    addReport(){
      this.reportVisible = true
    },
    doAddReport(){
      if (!this.addInfo.name) {
        this.$message.error("名称必须")
        return
      }
      if (!this.addInfo.dimension.length&&!this.addInfo.data.length){
        this.$message.error("维度或指标必须")
        return
      }
      AddPanel(this.addInfo).then(resp => {
        if (resp.code===200){
          this.reportVisible = false
          this.$router.push({
            path:'/report_index',
            query:{
              app_id:this.$route.query.app_id,
              code:resp.data
            }
          })
        }
      })
    },
    addCompose(){
      this.composeVisible = true
    },
    doAddCompose(){
      AddNorm(this.composeInfo).then(resp => {
        if (resp.code===200){
          this.composeVisible = false
          this.composeChoice = []
          this.composeInfo = {
            rule:'',
            type:'data',
            category:'compose',
          }
          this.initNorm()
        }else{
          this.$message.error(resp.msg)
        }
      })

    }
  }
}
</script>

<style>
.norm-panel{
  display: flex;
  margin: 5px 0;
}
.norm-panel-label{
  margin: 5px 0;
  min-width: 60px;
}
.norm-panel-item{
  margin: 5px 5px;
  padding:0 5px;
  float: left;
  cursor: pointer;
  border-radius: 5px;
}
.norm-panel-item.active{
  color: #1890ff;
}
.text-no{
  color: rgba(0,0,0,0.25);
}
</style>



// WEBPACK FOOTER //
// src/views/Report/Add.vue